package com.macrofocus.eflux.components

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.common.properties.Property
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.link.*
import com.macrofocus.eflux.network.Node
import com.macrofocus.eflux.network.NodeField
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.substation.Substation
import com.macrofocus.eflux.ui.data.LineButton
import emotion.react.css
import mui.material.*
import mui.material.Size
import mui.system.responsive
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.PropsWithChildren
import react.ReactNode
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.hr
import web.cssom.*

external interface NodeInfoExtraProps : PropsWithChildren {
    var primary: Boolean
    var dataLoader: DataLoader
    var node: Node?
    var substation: Substation
    var tooltipNodes: Property<Array<NodeField<*>>>
    var masterDateTime: String?
    var expertMode: Boolean
    var tab: MutableProperty<String>
}

val NodeInfoExtra = FC<NodeInfoExtraProps> { props ->
    val dataLoader = props.dataLoader
    val node = props.node
    val substation = props.substation
    val masterDateTime = props.masterDateTime
    val expertMode = props.expertMode

    val (getSubstationNetwork, _) = useProperty(dataLoader.substationNetwork)

    val (tab, setTab) = useProperty(props.tab)

    ReactHTML.div {
        css {
            height = 10.px
        }
    }

    Tabs {
        this.value = tab
        variant = TabsVariant.fullWidth
        asDynamic().size = Size.small
        onChange = { _, newValue -> setTab(newValue.toString()) }

        Tab {
            sx {
                textTransform = None.none
            }
            label = ReactNode("Lines")
            this.value = "lines"

        }
        Tab {
            sx {
                textTransform = None.none
            }
            label = ReactNode("Links")
            this.value = "links"
        }
    }

    when(tab) {
        "lines" -> {
            Stack {
                direction = responsive(StackDirection.column)
                asDynamic().justifyContent = JustifyContent.center
                sx {
                    paddingTop = 10.px
                    marginBottom = 3.px
                    maxHeight = 100.pct
                    overflowY = Auto.auto
                }

                val substations: MutableMap<LogicalBusId, Substation>? = getSubstationNetwork?.substations
                val key: LogicalBusId? = node?.id
                val s: Substation? = substations?.get(key)
                if (s != null) {
                    for (line in getSubstationNetwork.getLinks(s)) {
                        Stack {
                            direction = responsive(StackDirection.row)
                            asDynamic().justifyContent = JustifyContent.center

                            LineButton {
                                this.dataLoader = dataLoader
                                this.primary = props.primary
                                this.probing = if(props.primary) dataLoader.controller.secondaryLogicalBranchProbing else dataLoader.controller.primaryLogicalBranchProbing
                                this.selection = if(props.primary) dataLoader.controller.secondaryLogicalBranchSelection else dataLoader.controller.primaryLogicalBranchSelection
                                this.logicalBranchId = line.logicalBranchId
                            }
                        }
                    }
                }
            }
        }

        "links" -> {
            Box {
                sx {
                    display = Display.flex
                    flexDirection = FlexDirection.column
                    maxHeight = 100.pct
                    marginTop = 10.px
                    overflowY = Auto.auto
                }

                if (expertMode) {
                    InstantZoomButton {
                        this.dataLoader = dataLoader
                        geometry = substation.physicalGeometry
                        margin = 0.25
                    }
                }

                if (expertMode) {
                    AnimatedZoomButton {
                        this.dataLoader = dataLoader
                        geometry = substation.physicalGeometry
                        margin = 0.25
                    }
                }

                GoogleMapLink {
                    geometry = substation.physicalGeometry
                    margin = 0.25
                }

                GoogleStreetViewLink {
                    geometry = substation.physicalGeometry
                }

                OpenInfraMapLink {
                    geometry = substation.physicalGeometry
                    margin = 0.25
                }

                hr {}

                substation.salesforce?.let {
                    SalesforceLink {
                        url = it
                    }
                }
                substation.tDMS?.let {
                    tDMSLink {
                        url = it
                    }
                }
                substation.dMZUWHSZ?.let {
                    DMZUWHSZLink {
                        url = it
                    }
                }
                substation.sapAssetViewer?.let {
                    SAPAssetViewerLink {
                        url = it
                    }
                }
            }
        }
    }
}

